<form [formGroup]="formName">
  <div class="form-container">
    <mat-form-field appearance="outline">
      <mat-label [attr.for]="field.fieldName">{{ field.label }}</mat-label>
      <input
        matInput
        [formControlName]="field.fieldName"
        [id]="field.fieldName"
        type="text"
        />
        <button matSuffix mat-icon-button>
          <mat-icon>search</mat-icon>
        </button>
        @if (formName.controls[field.fieldName].hasError('required')) {
          <mat-error
            >Debe completar el campo {{ field.label }}.
          </mat-error>
        }
      </mat-form-field>
      @if (field.icon) {
        <span
          class="icon-container"
			[ngClass]="
				formName.controls[field.fieldName].valid ? 'valid' : 'not-valid'
			"
          >
          <mat-icon matListItemIcon class="icon">{{ field.icon }}</mat-icon>
        </span>
      }
    </div>
  </form>
